export const MEAL_TYPE_COLORS: { [key: string]: string } = {
  Almoço: "#10b981",
  "Café da Manhã": "#f59e0b",
  Jantar: "#3b82f6",
  Lanche: "#ec4899",
  Bebida: "#85368c",
  "Lanche da Manhã": "#fbbf24",
  "Lanche da Tarde": "#14b8a6",
  "Lanche da Noite": "#6366f1",
  Brunch: "#f97316",
  "Pré-treino": "#ef4444",
  "Pós-treino": "#06b6d4",
  Suplemento: "#a855f7",
  Sobremesa: "#f43f5e",
  Outro: "#64748b",
};

export const WEEKDAY_COLORS: { [key: string]: string } = {
  Segunda: "#3b82f6",
  Terça: "#85368c",
  Quarta: "#ec4899",
  Quinta: "#f59e0b",
  Sexta: "#10b981",
  Sábado: "#ef4444",
  Domingo: "#facc15",
};

export const FILTER_OPTIONS = [
  { label: "7 dias", value: 7 },
  { label: "15 dias", value: 15 },
  { label: "30 dias", value: 30 },
  { label: "60 dias", value: 60 },
  { label: "90 dias", value: 90 },
];
